import React, { useContext } from 'react';
import { getContext } from 'common';
import { TreeNodeContext } from './';
import Styled from './styles';

export interface TreeContextMenuProps extends React.ComponentPropsWithRef<'div'> {
  /** TreeContextMenu children. Consider using `MoreButton`. */
  children: React.ReactNode;
  /** Hide context menu. */
  hide?: boolean;
}

/** Component to add a context menu to a Tree. Any other props will be provided to the root element. */
const TreeContextMenu = React.forwardRef<HTMLElement, TreeContextMenuProps>((props: TreeContextMenuProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    hide,
    ...otherProps
  } = props;
  const treeNodeContext = useContext(TreeNodeContext);
  const hideContextMenu = !treeNodeContext.selected && !treeNodeContext.isFocused && !treeNodeContext.isHovered;
  return (
    <Styled.TreeContextMenu
      ref={ref}
      RTL={RTL}
      hide={hideContextMenu || hide}
      tabIndex={-1}
      {...otherProps}
    >
      {children}
    </Styled.TreeContextMenu>
  );
}));

TreeContextMenu.displayName = 'TreeContextMenu';

TreeContextMenu.defaultProps = {
  hide: false,
};


export default TreeContextMenu;
